export default __webpack_public_path__ + "static/media/noteTaker.1c8ff25d.png";